



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { defineComponent, ref, onMounted } from '@nuxtjs/composition-api';
import { getMetaInfo } from '~/helpers/getMetaInfo';

export default defineComponent({
    name: "MeetTheTeam",
    setup () {
        onMounted( () => {
            console.log('page content loaded!');
        });
        const activeShowId = ref(null);
        const scrollToSection = (id, showId) => {
            if (activeShowId.value && activeShowId.value !== showId) {
                const prevElement = document.getElementById(activeShowId.value);
                if (prevElement) {
                prevElement.style.display = "none";
                }
            }

            const showElement = document.getElementById(showId);
            if (showElement) {
                showElement.style.display = "block";
                activeShowId.value = showId;
            }

            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        };

        const scrollToMainSection = (id) => {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        };

        const closeSection = (id) => {
            const element = document.getElementById(id);
            if (element) {
                element.style.display = "none";
            }
        };

        const pageMeta = {
            "meta_title": "Midwest Photo Meet the MPEX Team!",
            "meta_description": null,
            "meta_keywords": null,
            "name": "Midwest Photo Meet the MPEX Team!",
        };

        return {
            scrollToSection,
            scrollToMainSection,
            closeSection,
            pageMeta
        }
    },
    head() {
        return getMetaInfo(this.pageMeta);
    },
});
